import requestor from "requestor";
import BaseRoute from "utils/base_route";
import getRouteIds from "utils/get_route_ids";
import MatterEditor from "./containers/matter_editor";

import projectFetchAction from "modules/projects/actions/project_fetch";
import matterFetchAction from "modules/matters/actions/fetch_matter";
import clearMatterAction from "modules/matters/actions/clear_matter";

export default class MatterEditorRoute extends BaseRoute {
  constructor(store, path) {
    super(path, store);
  }

  getComponents(location, cb) {
    cb(null, MatterEditor);
  }

  fetchActiveData(props) {
    const {organisationId, projectId, matterId} = getRouteIds(props.router);

    this.fetchProject(organisationId, projectId);

    const parsedMatterId = parseInt(matterId, 10);
    if (!isNaN(parsedMatterId)) {
      this.fetchMatter(organisationId, projectId, parsedMatterId);
    }
  }

  fetchProject(organisationId, projectId) {
    if (projectId) {
      this.store.dispatch(
        projectFetchAction(requestor)(organisationId, projectId),
      );
    }
  }

  fetchMatter(organisationId, projectId, matterId) {
    this.store.dispatch(
      matterFetchAction(requestor)(organisationId, projectId, matterId, true),
    );
  }

  clearActiveData() {
    const {dispatch} = this.store;
    dispatch(clearMatterAction());
  }
}
